import styled from "rn-css";
import { spacing_s, white_smoke } from "../../StyleHelpers";

//Wide
export const StyledWideMainContent = styled.View`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: ${spacing_s};
	flex: 1 0 0;
`;

export const StyledWideContent = styled.View`
	display: flex;
	align-items: flex-start;
	flex-direction: row;
	gap: 3rem;
	align-self: stretch;
`;

export const StyledWideTextContent = styled.View`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.75rem;
	flex: 1 0 0;
	width: 100%;
`;

export const StyledWideBodyContent = styled.Text`
	color: ${white_smoke};
	font-size: 1.5625rem;
	font-style: normal;
	font-weight: 400;
	line-height: 1.75rem;
`;

export const StyledLegalTitleStyle = styled.Text<{ isNarrow?: boolean }>`
	color: ${white_smoke};
	text-align: left;
	font-size: ${({ isNarrow }) => (isNarrow ? "2rem" : "2.3125rem")};
	font-style: normal;
	font-weight: 500;
	line-height: ${({ isNarrow }) => (isNarrow ? "2.5rem" : "2.75rem")};
`;

export const StyledButtonContainer = styled.View`
	display: flex;
	flex-direction: row;
	gap: 1.5rem;
	align-self: stretch;
`;

export const StyledWideFooter = styled.View`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 1.5rem;
	align-self: stretch;
`;

//Narrow
export const StyledNarrowMain = styled.View`
	display: flex;
	padding: 6.5rem 8rem 1.5rem 8rem;
	align-items: flex-start;
	gap: ${spacing_s};
	flex: 1 0 0;
	align-self: stretch;
	flex-direction: row;
`;

export const StyledNarrowButton = styled.View`
	display: flex;
	width: 31.25rem;
	flex-direction: column;
	align-items: flex-start;
	align-self: stretch;
	gap: ${spacing_s};
`;

export const StyledNarrowCreateButton = styled.View<{ isNarrow?: boolean }>`
	display: flex;
	width: 100%;
	gap: ${spacing_s};
`;

export const StyledNarrowMainContent = styled.View`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: ${spacing_s};
	flex: 1 0 0;
`;

export const StyledNarrowContent = styled.View`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: ${spacing_s};
	align-self: stretch;
`;

export const StyledNarrowTextContent = styled.View`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.75rem;
	flex: 1 0 0;
`;

export const StyledNarrowBodyContent = styled.Text`
	color: ${white_smoke};
	font-size: 1.3125rem;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5625rem;
`;
